/**
 * When Matchmaking V2 API is on, leftover *draft question* intake routes
 * redirect to screening. Post-match / session / portal / booking shells stay reachable.
 */
import {isMatchmakingV2ApiEnabled} from '@/intake/sandboxMatchApi'

/** Routes that remain reachable when the V2 intake API is enabled. */
export const V2_INTAKE_ROUTE_ALLOWLIST = new Set([
  'intakeScreening',
  'intakeDisp',
  'intakeCrisis',
  'intakeMatching',
  'intakeMatches',
  'intakeTherapist',
  'intakeSlots',
  'intakeHold',
  'intakeConflict',
  'intakeHoldExpired',
  'intakeCheckout',
  'intakePayReturn',
  'intakePayProcessing',
  'intakePaySuccess',
  'intakePayFail',
  'intakePayMismatch',
  'intakePayLate',
  'intakeSessionReschedule',
  'intakeSessionCancel',
  'intakeConsent',
  'intakeBaseline',
  'intakeLetter',
  'intakeLetterVoice',
  'intakeClientHome',
  'intakeReadyLock',
  'intakeReadyOk',
  'intakeSessionCheck',
  'intakeSessionAvCheck',
  'intakeSessionWait',
  'intakeSessionRoom',
  'intakeSessionReconnect',
  'intakeSessionEnd',
  'intakeSessionOutcome',
  'intakeOutcomeSrs',
  'intakeOutcomeOrs',
  'intakeAssessDone',
  'intakeAssessMiss',
  'intakeNotify',
  'intakeConsentSigner',
  'intakeConsentGuard',
  'intakeMatchExpired',
  'intakeMatchGap',
  'intakeMatchInvalid',
  'intakeMatchNoslot',
  'intakeRematchOffer',
  'intakeRematchDecide',
  'intakeRematchRun',
  'intakeRematchFail',
])

/**
 * @param {string|null|undefined} routeName
 * @returns {boolean} true if this intake child should redirect to screening
 */
export function shouldRedirectStaticIntakeRoute(routeName) {
  if (!isMatchmakingV2ApiEnabled()) {
    return false
  }
  if (!routeName || typeof routeName !== 'string') {
    return false
  }
  return routeName.indexOf('intake') === 0
    && !V2_INTAKE_ROUTE_ALLOWLIST.has(routeName)
}
